import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './nav-link.scss.js';

class NavLink extends s {
    constructor() {
        super(...arguments);
        this.text = '';
        this.href = '';
        this.ariaLabel = '';
        this.isNoFollow = false;
        this.target = '';
    }
    render() {
        const iconTemplate = this.icon
            ? $ `<span class="nav-link__icon"><span class="material-symbols-outlined" aria-hidden="true">${this.icon}</span></span>`
            : '';
        return $ `<a href="${this.href}" class="nav-link" aria-label="${this.ariaLabel || this.text}" target="${this.target || w}" rel="${this.isNoFollow ? 'nofollow' : 'follow'}">${iconTemplate} <span class="nav-link__text">${this.text}</span> <span class="nav-link__chevron" aria-hidden="true"><span class="material-symbols-outlined">chevron_right</span></span></a>`;
    }
}
NavLink.styles = css_248z;
__decorate([
    e()
], NavLink.prototype, "text", void 0);
__decorate([
    e()
], NavLink.prototype, "href", void 0);
__decorate([
    e()
], NavLink.prototype, "ariaLabel", void 0);
__decorate([
    e()
], NavLink.prototype, "icon", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], NavLink.prototype, "isNoFollow", void 0);
__decorate([
    e({ type: String, reflect: true })
], NavLink.prototype, "target", void 0);
customElements.define('nav-link', NavLink);

export { NavLink };
